import React, { Component } from 'react';


class Donut extends Component {


  componentDidMount(){

  }

  render() {

    return (

        <div className="donut">
         </div>
  )
}
}
export default Donut;

